import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { api } from '../lib/api';
import { useAuthStore } from '../store/auth.store';

type Props = {
  variant?: 'inline' | 'compact' | 'nav';
  className?: string;
};

export default function LogoutButton({ variant = 'inline', className = '' }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  function handleLogout() {
    void api.post('/auth/logout').catch(() => undefined);
    logout();
    navigate('/login');
  }

  if (variant === 'compact') {
    return (
      <button
        type="button"
        onClick={handleLogout}
        className={`p-2 rounded-xl text-red-600 hover:bg-red-50 transition-colors ${className}`}
        aria-label={t('nav.logout', { defaultValue: 'Déconnexion' })}
      >
        <LogOut size={18} aria-hidden />
      </button>
    );
  }

  if (variant === 'nav') {
    return (
      <button
        type="button"
        onClick={handleLogout}
        className={`ml-auto flex items-center gap-2 px-2.5 sm:px-3 py-2 rounded-xl text-sm font-semibold text-red-100 hover:bg-white/10 transition-colors min-h-11 ${className}`}
      >
        <LogOut size={16} aria-hidden />
        {t('nav.logout', { defaultValue: 'Déconnexion' })}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleLogout}
      className={`w-full flex items-center justify-center gap-2 px-3 py-2.5 rounded-xl border border-red-200 text-red-600 text-sm font-semibold hover:bg-red-50 transition-colors min-h-[44px] ${className}`}
    >
      <LogOut size={16} aria-hidden />
      {t('nav.logout', { defaultValue: 'Déconnexion' })}
    </button>
  );
}
